import "./Label.scss";
import { LabelProps } from "/Models/Generated/LabelProps";
import cn from "classnames";

interface Props extends LabelProps {
  compact?: boolean;
}

export const Label = ({ text, filled, outlined, compact }: Props) => (
  <div className="label-norad">
    <div
      className={cn("label-norad__container", {
        "label-norad__container--theme-filled": filled,
        "label-norad__container--theme-outline": outlined,
        "label-norad__container--theme-compact": compact,
      })}
    >
      {text && <div>{text}</div>}
    </div>
  </div>
);

export default Label;
